import { render, staticRenderFns } from "./App.vue?vue&type=template&id=398eb22a&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./App.vue?vue&type=style&index=0&id=398eb22a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/172.26.59.72+4873+vue-loader@15.10.1_6sfbhgu6kjcmlhpjwryimz4q4m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports